var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Autocomplete } from '@mui/material';
import Box from '@mui/material/Box';
import { HandleError } from '../modules/utils/HandleError';
import { DefaultInputProps } from '../model/DefaultInputProps';
import { CustomInputForm } from './Forms/CustomInputForm';
var DefaultAutoCompleteProps = /** @class */ (function (_super) {
    __extends(DefaultAutoCompleteProps, _super);
    function DefaultAutoCompleteProps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DefaultAutoCompleteProps;
}(DefaultInputProps));
export { DefaultAutoCompleteProps };
var EMPTY_ARRAY = [];
export var DefaultAutoComplete = function (_a) {
    var _b;
    var _c = _a.noOptionsText, noOptionsText = _c === void 0 ? 'Nenhum registro encontrado.' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? 'Selecione uma opção.' : _d, _e = _a.comparablefield, comparablefield = _e === void 0 ? 'id' : _e, _f = _a.defaultValue, defaultValue = _f === void 0 ? null : _f, _g = _a.fieldName, fieldName = _g === void 0 ? 'nome' : _g, _h = _a.otherOption, otherOption = _h === void 0 ? null : _h, _j = _a.position, position = _j === void 0 ? 'end' : _j, _k = _a.fieldsList, fieldsList = _k === void 0 ? [] : _k, renderOption = _a.renderOption, cbckSearch = _a.cbckSearch, fieldError = _a.fieldError, onChange = _a.onChange, refChange = _a.refChange, disabled = _a.disabled, label = _a.label, value = _a.value, name = _a.name, required = _a.required;
    //region Constants
    var _l = useState("".concat(crypto.getRandomValues(new Uint8Array(16)))), key = _l[0], setKey = _l[1];
    var _m = useState(null), selectedValue = _m[0], setSelectedValue = _m[1];
    var _o = useState([]), values = _o[0], setValues = _o[1];
    var _p = useState(), error = _p[0], setError = _p[1];
    var outroItem = (_b = otherOption !== null && otherOption !== void 0 ? otherOption : defaultValue) !== null && _b !== void 0 ? _b : null;
    var prevFieldsListRef = useRef(null);
    var labelFunction = useMemo(function () { return renderOption !== null && renderOption !== void 0 ? renderOption : (function (option) { var _a; return String((_a = option === null || option === void 0 ? void 0 : option[fieldName !== null && fieldName !== void 0 ? fieldName : 'nome']) !== null && _a !== void 0 ? _a : ''); }); }, [renderOption, fieldName]);
    //endregion
    //region Hooks
    var fieldsListMemo = useMemo(function () {
        return (fieldsList === null || fieldsList === void 0 ? void 0 : fieldsList.length) !== 0 ? fieldsList : EMPTY_ARRAY;
    }, [fieldsList]);
    useEffect(function () {
        setKey("".concat(crypto.getRandomValues(new Uint8Array(16))));
    }, []);
    useEffect(function () {
        handleRefresh();
    }, [refChange, otherOption, position]);
    useEffect(function () {
        var _a;
        if (value != null) {
            var compField_1 = comparablefield !== null && comparablefield !== void 0 ? comparablefield : 'id';
            var labelField_1 = (_a = fieldName) !== null && _a !== void 0 ? _a : 'nome';
            var match = values.find(function (opt) {
                var _a, _b;
                var oc = opt === null || opt === void 0 ? void 0 : opt[compField_1];
                var vc = value === null || value === void 0 ? void 0 : value[compField_1];
                if (oc == null || vc == null) {
                    return ((_a = opt === null || opt === void 0 ? void 0 : opt[labelField_1]) !== null && _a !== void 0 ? _a : '') === ((_b = value === null || value === void 0 ? void 0 : value[labelField_1]) !== null && _b !== void 0 ? _b : '');
                }
                return oc === vc;
            });
            if (match) {
                setSelectedValue(match);
                return;
            }
            if (outroItem) {
                var vc = value === null || value === void 0 ? void 0 : value[compField_1];
                var vLabel = value === null || value === void 0 ? void 0 : value[labelField_1];
                var oLabel = outroItem === null || outroItem === void 0 ? void 0 : outroItem[labelField_1];
                var looksLikeOutro = (vc == null) && (!vLabel || vLabel === oLabel);
                if (looksLikeOutro) {
                    setSelectedValue(outroItem);
                    return;
                }
            }
            setSelectedValue(value);
        }
        else {
            setSelectedValue(null);
        }
    }, [value, values, comparablefield, fieldName, outroItem]);
    useEffect(function () {
        if (prevFieldsListRef.current !== fieldsListMemo) {
            setValues(fieldsListMemo);
            prevFieldsListRef.current = fieldsListMemo;
        }
    }, [fieldsListMemo]);
    useEffect(function () {
    }, [values]);
    //endregion
    //region Handles
    var handleRefresh = function () { return __awaiter(void 0, void 0, Promise, function () {
        var baseValues, _a, positionValues, newValues, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    if (!cbckSearch) return [3 /*break*/, 2];
                    return [4 /*yield*/, cbckSearch()];
                case 1:
                    _a = (_b.sent());
                    return [3 /*break*/, 3];
                case 2:
                    _a = (fieldsList !== null && fieldsList !== void 0 ? fieldsList : []);
                    _b.label = 3;
                case 3:
                    baseValues = (_a);
                    positionValues = (position === 'start' ? __spreadArray([otherOption], baseValues, true) : __spreadArray(__spreadArray([], baseValues, true), [otherOption], false));
                    newValues = (otherOption ? positionValues : baseValues);
                    setValues(newValues);
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _b.sent();
                    setError(err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (newValue) {
        if (!newValue && defaultValue) {
            setSelectedValue(defaultValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(defaultValue);
        }
        else {
            setSelectedValue(newValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
        }
    };
    var handleCloseError = function () {
        setError(undefined);
    };
    var handleFilter = function (opts, filter) {
        return opts.filter(function (it) {
            var label = labelFunction(it);
            var nomeNorm = normalize(label);
            var query = filter.inputValue.trim().toLowerCase();
            var normQuery = normalize(query);
            return nomeNorm.toLowerCase().includes(normQuery);
        })
            .slice(0, 200);
    };
    var customInput = function (params) {
        return (_jsx(CustomInputForm, __assign({}, params, { inputProps: __assign(__assign({}, params.inputProps), { autoComplete: 'new-password' }), helperText: fieldError === null || fieldError === void 0 ? void 0 : fieldError["".concat(name, "Error")], error: !!(fieldError === null || fieldError === void 0 ? void 0 : fieldError["".concat(name, "Error")]), InputLabelProps: { shrink: true }, placeholder: placeholder, required: required, label: label })));
    };
    var handleCompare = function (option, value) {
        if (!option || !value)
            return false;
        var optionComp = option === null || option === void 0 ? void 0 : option[comparablefield !== null && comparablefield !== void 0 ? comparablefield : 'id'];
        var valueComp = value === null || value === void 0 ? void 0 : value[comparablefield !== null && comparablefield !== void 0 ? comparablefield : 'id'];
        if (optionComp == null || valueComp == null) {
            return (option === null || option === void 0 ? void 0 : option[fieldName !== null && fieldName !== void 0 ? fieldName : 'nome']) === (value === null || value === void 0 ? void 0 : value[fieldName !== null && fieldName !== void 0 ? fieldName : 'nome']);
        }
        return optionComp === valueComp;
    };
    var handleRenderOpt = function (props, option) {
        var _a, _b;
        return (_createElement(Box, __assign({}, props, { key: "".concat(name !== null && name !== void 0 ? name : 'autocomplete', "_").concat((_b = (_a = option[comparablefield !== null && comparablefield !== void 0 ? comparablefield : 'id']) !== null && _a !== void 0 ? _a : option[fieldName !== null && fieldName !== void 0 ? fieldName : 'nome']) !== null && _b !== void 0 ? _b : key), sx: { display: 'flex', alignItems: 'center' }, component: "li" }), labelFunction(option)));
    };
    var normalize = function (value) { var _a; return (_a = value === null || value === void 0 ? void 0 : value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) !== null && _a !== void 0 ? _a : ''; };
    //endregion
    return (_jsxs(_Fragment, { children: [_jsx(Autocomplete, { onChange: function (_, newValue) { return handleChange(newValue); }, id: "".concat(name !== null && name !== void 0 ? name : 'autocomplete', "_").concat(label !== null && label !== void 0 ? label : 'campo'), isOptionEqualToValue: handleCompare, renderOption: handleRenderOpt, getOptionLabel: labelFunction, noOptionsText: noOptionsText, filterOptions: handleFilter, renderInput: customInput, value: selectedValue, disabled: disabled, options: values, autoHighlight: true, fullWidth: true }), _jsx(HandleError, { error: error, handleClose: handleCloseError })] }));
};
